"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../../constants");
exports.attrToSelector = (attr) => {
    // eslint-disable-next-line no-useless-escape
    return `[${constants_1.OSYS_ATTRS[attr].replace(/\:/, '\\:')}]`;
};
//# sourceMappingURL=attrToSelector.js.map